<template>
  <form id="crewInfo" class="card" @submit.prevent="confirmUpdateCrewInfo">
    <div class="card-body">
      <div class="card-title font-weight-bold">
        Crew Information
<!--        v-if="(isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest"-->
        <template>
          <button v-if="editable"
                  class="btn btn-sm btn-xs btn-danger float-right ml-2"
                  @click="cancelEdit"
          >
            <span class="fas fa-ban"></span>
          </button>
          <button class="btn btn-sm btn-xs btn-warning font-weight-bold float-right mb-1"
                  type="submit"
                  @mouseenter="highlighFields('crewInfo', true)"
                  @mouseleave="highlighFields('crewInfo', false)"
                  v-if="(crew.active_status_confirm == 1 || isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !guest && !isKline"
          >


            <span class="fas fa-user-edit"></span>
            {{ editable ? 'Update' : 'Edit Info' }}
          </button>
        </template>
        <hr class="mt-1 border-dark"/>
      </div>


      <div class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
               for="ipn"
        >
          Crew IPN:
        </label>
        <div class="col col-sm-3">
          <input id="ipn" v-model="crewEdit.ipn"
            :class="{
              'form-display':  !editable,
            }"
            class="form-control form-control-xs h-1x"
            type="text"
            disabled
          >
        </div>
        <div v-if="isDesignatedPrincipal || isBremen" class="col col-sm-auto">
          <button v-if="!crewEdit.ipn && !editable" class="btn btn-xs btn-warning font-weight-bold mr-2"
                  type="button"
                  @click="confirmGenerateCrewIpn"
          >
            <i class="fas fa-users-cog"></i>
            Generate Crew IPN
          </button>

          <button v-if="!crewEdit.ipn && !editable && !crewEdit.code && isSystemAdmin" class="btn btn-xs btn-warning font-weight-bold bg-lightblue"
                  type="button"
                  @click="confirmGenerateCrewCode"
          >
            <i class="fas fa-users-cog"></i>
            Generate Crew Code
          </button>
        </div>
      </div>

      <div v-if="!crewEdit.ipn" class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs pr-0"
               for="ipn">
          Temporary Crew Code:
        </label>
        <div class="col col-sm-4">
          <input id="tempCrewCode" v-model="crewEdit.code"
                 class="form-control form-control-xs h-1x form-display"
                 readonly
                 type="text">
        </div>
      </div>

      <div :class="{'has-error': crewInfoErrors.rank_id}" class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
               for="rank"
        >
          Rank:
        </label>
        <div class="col col-sm-4">
          <select v-if="editable"
                  id="rank"
                  v-model="crewEdit.rank_id"
                  class="form-control form-control-xs h-1x p-0"
          >
            <option :value="null">-----</option>
            <option v-for="rankKey in rankKeys" :key="rankKey.id"
                    :selected="rankKey.id === crewEdit.rank_id"
                    :value="rankKey.id"
            >{{ rankKey.alias }}
            </option>
          </select>
          <input v-if="crewEdit.rank && !editable" :value="crewEdit.rank ? crewEdit.rank.alias : '-----'"
                 class="form-control form-control-xs form-display h-1x"
                 readonly
                 type="text"
          >
          <span v-if="crewInfoErrors.rank_id !== ''" class="help-block">
                        <small><strong>{{ crewInfoErrors.rank_id }}</strong></small>
                    </span>
        </div>

        <template v-if="editable">
          <div class="col col-sm-1 text-right pr-0">
            <input id="for-promotion" v-model="crewEdit.for_promotion"
                   class="form-check-input"
                   type="checkbox"
            >
          </div>
          <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs text-left pl-0"
                 for="for-promotion"
          >
            For Promotion
          </label>
        </template>



      </div>

      <div class="form-group form-row mb-1" v-if="crewEdit.promoted_rank || crewEdit.for_promotion">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs text-left"
               for="promoted-rank"
        >
          Promoted Rank:
        </label>
        <div v-if="editable && crewEdit.for_promotion" class="col col-sm-4">
          <select v-if="editable"
                  id="promoted-rank"
                  v-model="crewEdit.promoted_rank_id"
                  class="form-control form-control-xs h-1x p-0"
          >
            <option :value="null">-----</option>
            <option v-for="rankKey in promotedRankSelection" :key="rankKey.id"
                    :selected="rankKey.id === crewEdit.promoted_rank_id"
                    :value="rankKey.id"
            >{{ rankKey.alias }}
            </option>
          </select>

        </div>
        <div v-if="crewEdit.promoted_rank" class="col col-sm-4">
          <input v-if="crewEdit.promoted_rank && !editable" :value="crewEdit.promoted_rank ? crewEdit.promoted_rank.alias : '-----'"
                 class="form-control form-control-xs  form-display h-1x"
                 readonly
                 type="text"
          >
        </div>
      </div>

      <div class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
               for="type"
        >
          Crew Type:
        </label>
        <div class="col col-sm-4">
          <!--                    <input type="text" readonly id="type"-->
          <!--                           class="form-control form-control-xs form-display h-1x"-->
          <!--                           value="N/A"-->
          <!--                    >-->
          <select v-if="editable"
                  id="type"
                  v-model="crewEdit.crew_type_id"
                  class="form-control form-control-xs h-1x p-0"

          >
<!--            <option :value="false">Regular</option>-->
<!--            <option :value="true">Scholar</option>-->
<!--            <option :value="true">Student Office Trainee</option>-->
            <option :value="crewType.id" v-for="(crewType,index) in crewTypeKeys" :key="index">{{crewType.name}}</option>
          </select>
<!--          <input v-else :value="scholar ? 'SCHOLAR' : 'REGULAR'" class="form-control form-control-xs form-display h-1x"-->
<!--                 readonly-->
<!--                 type="text"-->
<!--          >-->
          <input v-else :value="crewEdit.crew_type ? crewEdit.crew_type.name : ''" class="form-control form-control-xs form-display h-1x"
                 readonly
                 type="text"
          >
        </div>
      </div>

      <div :class="{'has-error': crewInfoErrors.date_hired}" class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
               for="date_hired"
        >
          Date Hired:
        </label>
        <div class="col col-sm-4">
          <input v-if="editable" id="date_hired"
                 v-model="crewEdit.date_hired"
                 class="form-control form-control-xs h-1x"
                 type="date"
          >
          <input v-if="crewEdit.date_hired && !editable" :value="crewEdit.date_hired | moment('D MMM YYYY')"
                 class="form-control form-control-xs form-display h-1x"
                 readonly
                 type="text"
          >
          <input v-else-if="!crewEdit.date_hired && !editable" class="form-control form-control-xs form-display h-1x"
                 readonly
                 type="text"
                 value="------"
          >
          <span v-if="crewInfoErrors.date_hired !== ''" class="help-block">
                        <small><strong>{{ crewInfoErrors.date_hired }}</strong></small>
                    </span>
        </div>
      </div>

      <div v-if="[2,4].includes(crewEdit.crew_type_id)" :class="{'has-error': crewInfoErrors.scholarId}" class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text- form-label-xs"
               for="scholar"
        >
          Scholar Type:
        </label>
        <div class="col col-sm-4">
          <select v-if="editable"
                  id="scholar"
                  v-model="scholarId"
                  class="form-control form-control-xs h-1x p-0"
          >
            <option :value="null">-----</option>
            <option v-for="scholarKey in scholarKeysFiltered" :key="scholarKey.id"
                    :selected="scholarKey.id === scholarId"
                    :value="scholarKey.id"
            >{{ scholarKey.name }}
            </option>
          </select>
          <input v-if="crewEdit.crew_scholar && !editable" :value="crewEdit.crew_scholar ? crewEdit.crew_scholar.scholar.name : '------'"
                 class="form-control form-control-xs form-display h-1x"
                 readonly
                 type="text"
          >
          <span v-if="crewInfoErrors.scholarId !== ''" class="help-block">
                        <small><strong>{{ crewInfoErrors.scholarId }}</strong></small>
                    </span>
        </div>
      </div>

      <div :class="{'has-error': crewInfoErrors.active}" class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text- form-label-xs"
               for="crewStatus"
        >
          Status:
        </label>
        <div class="col col-sm-4">
          <select v-if="editable &&  (isOchg || isKobe ||(isStargate && isDesignatedPrincipal))"
                  id="crewStatus"
                  v-model="crewEdit.active"
                  class="form-control form-control-xs h-1x p-0"

          >
            <option :value="1">ACTIVE</option>
            <option :value="0">INACTIVE</option>
          </select>
          <input v-else :value="crewEdit.active ? 'ACTIVE' : 'INACTIVE'" class="form-control form-control-xs form-display h-1x"
                 readonly
                 type="text"
          >
          <span v-if="crewInfoErrors.active !== ''" class="help-block">
                        <small><strong>{{ crewInfoErrors.active }}</strong></small>
                    </span>
        </div>
      </div>

      <div :class="{'has-error': crewInfoErrors.manning_id}" class="form-group form-row mb-1">
        <label class="col col-sm-3 col-form-label font-weight-bolder text- form-label-xs"
               for="manning-select"
        >
          Manning:
        </label>
        <div class="col col-sm-4">
          <select v-if="editable && (isSystemAdmin || isPrincipal || isPrincipalStaff)"
                  id="manning-select"
                  v-model="crewEdit.manning_id"
                  class="form-control form-control-xs h-1x p-0"

          >
            <option :value="null">-----</option>
            <option v-for="manningKey in manningKeys" :key="manningKey.id"
                    :selected="manningKey.id === crewEdit.manning_id"
                    :value="manningKey.id"
            >{{ manningKey.alias }}
            </option>
          </select>
          <input v-else :value="crewEdit.manning ? crewEdit.manning.alias : '-----'" class="form-control form-control-xs form-display h-1x"
                 readonly
                 type="text"
          >
          <span v-if="crewInfoErrors.manning_id !== ''" class="help-block">
                  <small><strong>{{ crewInfoErrors.manning_id }}</strong></small>
              </span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from "../../../../../../../mixins/vueAppMixin";
import {formMixin} from "../../../../../../../mixins/formMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {cloneDeep} from "lodash/lang";
import {GlobalService} from "../../../../../../../services/GlobalService";

export default {
  name: "CrewInfo",
  mixins: [vueAppMixin, formMixin, gateMixin],
  data() {
    return {
      editable: false,
      crewEdit: {},
      crewInfoErrors: {},
      scholarId: null,
      scholar: false,
      promotedRankSelection: [],
      promotedRank: null,

      scholarKeysFiltered:[],

      crewCopy: {},
      crewDataFromCrewCopy: {}
    }
  },

  methods: {
    ...mapActions([
            'getCrewInfo',
            'getRankKeys',
            'updateCrewInfo',
            'getScholarKeys',
            'getManningKeys',
            'generateCrewIpn',
            'generateCrewCode',
            'getCrewTypeKeys'
        ]),
    async confirmUpdateCrewInfo() {
      if (!this.editable) {
        this.editable = true
        return
      }

      if (!await this.confirmUpdate('Are you sure you want to update this record?')) {
        this.crewEdit = cloneDeep(this.crew)
        return
      }

      const params = {
        crew_id: this.crewEdit.id,
        ipn: this.crewEdit.ipn,
        rank_id: this.crewEdit.rank_id,
        date_hired: this.crewEdit.date_hired,
        scholarId: [2,4].includes(this.crew.crew_type_id) ? this.scholarId : null,
        crew_type_id:this.crewEdit.crew_type_id,
        active: this.crewEdit.active,
        for_promotion: this.crewEdit.for_promotion ? 1 : 0,
        manning_id: this.crewEdit.manning_id,
      }

      if (this.crewEdit.promoted_rank_id) {
        params.promoted_rank_id = this.crewEdit.promoted_rank_id
      }

      const crewInfo = await this.updateCrewInfo(params)

      if (crewInfo.errors) {
        this.crewInfoErrors = crewInfo.errors
        GlobalService.handleRequestErrors(crewInfo.errors, 'Update Crew Info');
        return
      }

      const crewWasChangeToInactive =
        (this.crew.active !== this.crewEdit.active) &&
        !Boolean(this.crewEdit.active)

      if (crewWasChangeToInactive) {
        await this.$router.push({
          name: 'CrewActivity',
          params: {id: this.crew.id}
        });
        const message = 'Crew information has been successfully updated. ' +
          'Kindly ensure that the appropriate end reason is provided for inactive status.'

        //Can't use alert service successAlert method as it does not return a promise and is
        //causing conflict here hence we use swal directly
        await successAlert.fire({
          title: 'UPDATE',
          text: message,
          showConfirmButton: true,
          // timer: 5000,
          scrollbarPadding: false
        })
      } else {
        await successAlert.fire({
          title: 'UPDATE',
          text: 'Crew Info Successfully Updated',
          showConfirmButton: true,
          timer: 1500,
          scrollbarPadding: false
        })
      }

      await this.getCrewInfo({crewId: this.crew.id})

      this.editable = false
      this.crewInfoErrors = {}
      this.crewEdit = cloneDeep(this.crew)

      // Unless you are an admin, you can't edit the crew info unless it is active.
      if (this.crew.active) {
        this.crew.active_status_confirm = 1
      } else {
        this.crew.active_status_confirm = 0
      }
    },

    async confirmGenerateCrewIpn() {
      if (await this.confirmUpdate()) {
        let params = {crewId: this.crew.id};
        let generatedCrewIpn = this.generateCrewIpn(params);
        if (generatedCrewIpn) {
          this.successAlert('Crew IPN Successfully Generated', 'GENERATE');
        }
      }
    },

    async confirmGenerateCrewCode() {
      if (await this.confirmUpdate()) {
        let params = {crewId: this.crew.id};
        let generatedCrewIpn = this.generateCrewCode(params);
        if (generatedCrewIpn) {
          this.successAlert('Crew Code Successfully Generated', 'GENERATE');
        }
      }
    },
    async promotedRankInit() {
      if (this.crew.rank_id === 16) this.promotedRankSelection = this.rankKeys.filter(rank => [14, 8].includes(rank.id));
      if (this.crew.rank_id === 15) this.promotedRankSelection = this.rankKeys.filter(rank => [13, 7].includes(rank.id));
      if (this.crew.rank_id === 34) this.promotedRankSelection = this.rankKeys.filter(rank => [33, 17, 18].includes(rank.id));
      if (![16, 15, 34].includes(this.crew.rank_id)) this.promotedRankSelection = this.rankKeys;
    },

    async scholarKeysInit() {
      const manning_names = this.manningKeys.map(item=>item.alias);
      if(this.crew.crew_type_id == 4) {
        this.scholarKeysFiltered = this.scholarKeys.filter(item => [1,2,3,13].includes(item.id));
      }
      if(this.crew.crew_type_id == 2) {
        this.scholarKeysFiltered = this.scholarKeys.filter(item => {
          let scholarTypeManinngExist=manning_names.some(item2=>{return item.name.includes(item2)})
          let selectedManning=this.manningKeys.find(mann=> mann.id == this.crew.manning_id)?.alias ?? ''
          if(scholarTypeManinngExist) {
            if(item.name.toLowerCase().includes(selectedManning.toLowerCase())){
              return 1
            }
            return 0
          }
          return 1
        })
      }
      if(![4,2].includes(this.crew.crew_type_id)) this.scholarKeysFiltered=this.scholarKeys;
    },

    async cancelEdit() {
      this.editable = false;
      this.crewInfoErrors = {}
      this.crewEdit = cloneDeep(this.crew)
    },

  },

  computed: {
    ...mapGetters(['crew', 'rankKeys', 'scholarKeys', 'manningKeys','crewTypeKeys'])
  },
  watch: {
    async 'crew.rank_id'() {
      await this.promotedRankInit();
    },
    async 'crew.crew_type_id'() {
      await this.scholarKeysInit();
    },
    async 'crew.manning_id'(){
      await this.scholarKeysInit();
    }
  },
  async created() {
    await this.getRankKeys();
    await this.getScholarKeys();
    await this.getManningKeys();
    await this.promotedRankInit();
    await this.getCrewTypeKeys();
    this.scholarKeysInit();
    this.scholarId = this.crew.crew_scholar ? this.crew.crew_scholar.scholar.id : null;
    this.scholar = !!this.scholarId;

    this.crewEdit = cloneDeep(this.crew)
  },
}
</script>

<style scoped>

</style>
